import { render, staticRenderFns } from "./CommunityCareDay.vue?vue&type=template&id=5e5a0849&"
import script from "./CommunityCareDay.vue?vue&type=script&lang=js&"
export * from "./CommunityCareDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports